import React from "react";
import PropTypes from "prop-types";
import { Container, Input, Label, ImagePreview } from "./styles";

// Image preview
export const UIComponent = ({ name, imagePreview, imageStyle, ...otherProps }) => {
  /* eslint-disable */
  const IMAGE_AZURE_URL = process.env.REACT_APP_IMAGE_AZURE_URL;
  /* eslint-enable */
  const imageLocalUrl = imagePreview ? URL.createObjectURL(imagePreview) : null;

  return (
    <Container>
      {imagePreview || otherProps.imageURLPreview ? (
        <ImagePreview
          src={imageLocalUrl || `${IMAGE_AZURE_URL}/images-organizations/${otherProps.imageURLPreview}`}
          style={imageStyle}
        />
      ) : null}

      <Input type="file" {...otherProps} />
      <Label htmlFor={name}>Cargar imagen</Label>
    </Container>
  );
};

UIComponent.propTypes = {
  name: PropTypes.string.isRequired,
  imagePreview: PropTypes.object,
  imageStyle: PropTypes.object,
};
